import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY || 'http://localhost:3000/';

/**
 * Obtiene el listado de cotizaciones.
 * La paginación y ordenamiento se manejan en el frontend; el rango de fechas
 * y el estatus se filtran en el servidor.
 *
 * @param {Object} [filtros]
 * @param {string} [filtros.start] - Fecha de inicio (YYYY-MM-DD)
 * @param {string} [filtros.end] - Fecha de fin (YYYY-MM-DD)
 * @param {number|number[]|string} [filtros.estatus] - Un estatus, un arreglo
 *   de estatus (p. ej. [1, 2, 3]) o un string separado por comas ("1,2,3")
 * @returns {Promise<{success: boolean, data: Array}>}
 */
export const getQuotesList = async ({ start, end, estatus } = {}) => {
    try {
        const params = {};
        if (start) params.start = start;
        if (end) params.end = end;
        if (estatus !== undefined && estatus !== null && estatus !== '') {
            params.estatus = Array.isArray(estatus) ? estatus.join(',') : estatus;
        }

        const response = await api.get(`${urlApi}/quotes`, { params });

        return response.data;
    } catch (error) {
        console.error('Error al obtener cotizaciones:', error);
        return { success: false, data: [] };
    }
};

/**
 * Elimina una cotización por su ID.
 *
 * @param {string|number} id
 * @param motivo
 * @param user
 * @returns {Promise<{success: boolean}>}
 */
export const deleteQuote = async (id, motivo, user) => {
    try {
        await api.delete(`${urlApi}/quotes/${id}/delete`, {
            params: { motivo, user },
        });
        return { success: true };
    } catch (error) {
        console.error('Error al eliminar cotización:', error);
        return { success: false };
    }
};
/**
 * Actualiza el estatus de una cotización por su ID.
 *
 * @param {string|number} id
 * @param {string|number} status
 * @param solicitudCambios
 * @returns {Promise<{success: boolean, data:Boolean}>}
 */
export const updateQuoteStatus = async (id, status, solicitudCambios) => {
    try {
        const response = await api.put(`${urlApi}/quotes/${id}/status/${status}`, {solicitudCambios});
        return response.data;
    } catch (error) {
        console.error('Error al eliminar cotización:', error);
        throw error;
    }
};

/**
 * Mapea el valor de estatus a etiqueta, severidad e icono
 * para el componente Tag de PrimeReact.
 *
 * @param {string} estatus
 * @returns {{label: string, severity: string|null, icon: string}}
 */
export const mapEstatusCotizacion = (estatus) => {
    const estatusMap = {
        BORRADOR: { label: 'Borrador', severity: 'warning', icon: 'pi pi-file-edit' },
        ENVIADA:  { label: 'Enviada',  severity: 'info',    icon: 'pi pi-send' },
        APROBADA: { label: 'Aprobada', severity: 'success', icon: 'pi pi-check-circle' },
        RECHAZADA:{ label: 'Rechazada',severity: 'danger',  icon: 'pi pi-times-circle' },
        CANCELADA:{ label: 'Cancelada',severity: null,       icon: 'pi pi-ban' },
    };

    return estatusMap[estatus] || { label: estatus, severity: null, icon: 'pi pi-question-circle' };
};
